import React, { createContext, useContext, useState, useCallback } from 'react';

const SharedFileContext = createContext(null);

export const useSharedFile = () => useContext(SharedFileContext);

export const SharedFileProvider = ({ children }) => {
  const [sharedFile, setSharedFile] = useState(null);
  // pendingIntent is a short-lived flag used by Layout.js to hold the
  // default post-login redirect while an Android share intent is being
  // resolved asynchronously (cold-start race condition fix).
  const [pendingIntent, setPendingIntent] = useState(false);

  const setFile = useCallback((file, fileName, fileType) => {
    setSharedFile({ file, fileName, fileType });
    setPendingIntent(false);
  }, []);

  const clearFile = useCallback(() => {
    setSharedFile(null);
    setPendingIntent(false);
  }, []);

  return (
    <SharedFileContext.Provider
      value={{ sharedFile, pendingIntent, setFile, clearFile, setPendingIntent }}
    >
      {children}
    </SharedFileContext.Provider>
  );
};
